var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckTick01 = function SvgCheckTick01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "check_tick-01_svg2__a",
    x1: 10.39,
    x2: 163.43,
    y1: 155.08,
    y2: 38.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M195.71 31.43c-5.71-5.71-14.29-5.71-20 0L68.57 138.57 24.28 94.28c-5.71-5.71-14.29-5.71-20 0s-5.71 14.29 0 20l54.29 54.29c2.86 2.86 5.71 4.29 10 4.29s7.14-1.43 10-4.29L195.71 51.43c5.71-5.71 5.71-14.29 0-20",
    style: {
      fill: "url(#check_tick-01_svg2__a)"
    }
  }));
};
export default SvgCheckTick01;